/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { uuid } from './uuid';

/**
 * A Device Make and Model combination
 */
export type DeviceMakeModelItem = {
	id?: uuid;
	/**
	 * The name of the device make, model and type
	 */
	name?: string;
	/**
	 * The name of the device make
	 */
	make?: string;
	/**
	 * The name of the device model
	 */
	model?: string;
	/**
	 * The type of device
	 */
	deviceType?: DeviceMakeModelItem.deviceType;
	/**
	 * THe pattern apporved status for the make and model
	 */
	patternApproved?: DeviceMakeModelItem.patternApproved;
};
export namespace DeviceMakeModelItem {
	/**
	 * The type of device
	 */
	export enum deviceType {
		LOGGER = 'Logger',
		MODULAR_METER = 'Modular Meter',
		SC_METER = 'SC Meter',
		SENSOR = 'Sensor',
		TELEMETRY = 'Telemetry',
		WEIR_DISCHARGE = 'Weir Discharge',
		WL_STATION = 'WL Station',
	}
	/**
	 * THe pattern apporved status for the make and model
	 */
	export enum patternApproved {
		APPROVED = 'Approved',
		NOT_APPROVED = 'Not Approved',
		EXISTING_APPROVED = 'Existing Approved',
	}
}
